import { CollapsibleContainerClass, componentName } from './component/CollapsibleContainerClass';
import globals from '@descope-ui/theme-globals';
import { getThemeRefs, createHelperVars } from '@descope-ui/common/theme-helpers';


const globalRefs = getThemeRefs(globals);

const compVars = CollapsibleContainerClass.cssVarList;

const [helperTheme, helperRefs, helperVars] = createHelperVars(
  {
    shadowColor: '#00000020', // if we want to support transparency vars, we should use different color format
  },
  componentName
);

const { shadowColor } = helperRefs;

const collapsibleContainer = {
  ...helperTheme,

  [compVars.hostWidth]: '100%',
  [compVars.boxShadow]: 'none',

  [compVars.backgroundColor]: globalRefs.colors.surface.main,

  [compVars.backgroundImage]: '', // we need to set a value to avoid inner containers from inheriting the parent's background image
  [compVars.backgroundPositionX]: 'center',
  [compVars.backgroundPositionY]: 'center',
  [compVars.backgroundSize]: 'cover',
  [compVars.backgroundRepeat]: 'no-repeat',

  [compVars.borderRadius]: '0px',
  [compVars.hostDirection]: globalRefs.direction,

  [compVars.flexDirection]: 'column',
  [compVars.alignItems]: 'flex-start',
  [compVars.justifyContent]: 'flex-start',

  [compVars.headerGap]: globalRefs.spacing.md,

  [compVars.iconAnimationDuration]: '0.1s',
  [compVars.contentAnimationDuration]: '0.1s',

  [compVars.borderWidth]: '0px',
  [compVars.textGrow]: '0',

  verticalPadding: {
    sm: { [compVars.verticalPadding]: '5px' },
    md: { [compVars.verticalPadding]: '10px' },
    lg: { [compVars.verticalPadding]: '20px' },
  },

  horizontalPadding: {
    sm: { [compVars.horizontalPadding]: '5px' },
    md: { [compVars.horizontalPadding]: '10px' },
    lg: { [compVars.horizontalPadding]: '20px' },
  },

  spaceBetween: {
    sm: { [compVars.gap]: '10px' },
    md: { [compVars.gap]: '20px' },
    lg: { [compVars.gap]: '30px' },
  },

  shadow: {
    sm: {
      [compVars.boxShadow]: `${globalRefs.shadow.wide.sm} ${shadowColor}, ${globalRefs.shadow.narrow.sm} ${shadowColor}`,
    },
    md: {
      [compVars.boxShadow]: `${globalRefs.shadow.wide.md} ${shadowColor}, ${globalRefs.shadow.narrow.md} ${shadowColor}`,
    },
    lg: {
      [compVars.boxShadow]: `${globalRefs.shadow.wide.lg} ${shadowColor}, ${globalRefs.shadow.narrow.lg} ${shadowColor}`,
    },
    xl: {
      [compVars.boxShadow]: `${globalRefs.shadow.wide.xl} ${shadowColor}, ${globalRefs.shadow.narrow.xl} ${shadowColor}`,
    },
    '2xl': {
      [helperVars.shadowColor]: '#00000050', // mimic daisyUI shadow settings
      [compVars.boxShadow]: `${globalRefs.shadow.wide['2xl']} ${shadowColor}`,
    },
  },

  borderRadius: {
    sm: { [compVars.borderRadius]: globalRefs.radius.sm },
    md: { [compVars.borderRadius]: globalRefs.radius.md },
    lg: { [compVars.borderRadius]: globalRefs.radius.lg },
    xl: { [compVars.borderRadius]: globalRefs.radius.xl },
    '2xl': { [compVars.borderRadius]: globalRefs.radius['2xl'] },
    '3xl': { [compVars.borderRadius]: globalRefs.radius['3xl'] },
  },

  iconPosition: {
    'left': { [compVars.headerIconOrder]: '0' },
    'right': { [compVars.headerIconOrder]: '1' },
  },

  _fillTitle: {
    [compVars.textGrow]: '1',
  },

  _border: {
    [compVars.borderColor]: globalRefs.colors.surface.light,
    [compVars.borderWidth]: globalRefs.border.xs,
    [compVars.borderStyle]: 'solid',
  },

  _collapsible: {
    [compVars.headerCursor]: 'pointer',
  }
};

export default collapsibleContainer;

export const vars = {
  ...compVars,
  ...helperVars,
};
